import { Component, OnInit, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AccountAssessment, Assessment } from '../../../models/AssessmentModel';
import { AssessmentService, NistID } from '../../../services/assessment.service';
import { PlatformApiService } from '../../../services/platform-api.service';
import { SurveyModel } from 'survey-angular';

@Component({
  selector: 'app-subsection-detail',
  templateUrl: './subsection-detail.component.html',
  styleUrls: ['./subsection-detail.component.scss']
})
export class SubSectionDetailComponent implements OnInit {
  _assessment: Assessment;
  _accountAssessment: AccountAssessment;
  _selectedNistFunction: string;
  _selectedNistCategory: string;
  _selectedNistSubCategory: string;
  nistSubCategoryDetails;
  surveyModel: SurveyModel;
  questionData: any[];

  @Input()
  set accountAssessment(accountAssessment: AccountAssessment) {
    if (!this._accountAssessment || (this._accountAssessment && this._accountAssessment.id != accountAssessment.id)) {
      console.log('Setting account assessment');
      this._accountAssessment = accountAssessment;
      this._platformApi.loadAssessment(accountAssessment.assessmentId).subscribe(assessment => {
        this._assessment = assessment;
        this.surveyModel = new SurveyModel(this._assessment.json);
        this.loadSubSectionDetails();
      })
    }
  }

  @Input()
  set questionDetailSelection(questionDetailSelection: { nistFunction: string, nistSubCategory: string }) {
    const nistId = new NistID(questionDetailSelection.nistSubCategory);
    if (this._selectedNistFunction != questionDetailSelection.nistFunction || this._selectedNistSubCategory != questionDetailSelection.nistSubCategory) {
      this._selectedNistFunction = questionDetailSelection.nistFunction;
      this._selectedNistCategory = nistId.nistCategory;
      this._selectedNistSubCategory = questionDetailSelection.nistSubCategory;
      this.loadSubSectionDetails();
    }
  }
  get selectedNistSubCategoryName(): string {
    return `${this.nistSubCategoryDetails.id}: ${this.nistSubCategoryDetails.text}`;
  }
  get selectedNistFunctionName(): string {
    return AssessmentService.nistFunctionNames[this._selectedNistFunction];
  }

  loadSubSectionDetails() {
    if (this._accountAssessment && this._selectedNistFunction && this._selectedNistSubCategory) {
      console.log('Loading sub section details.');
      this.nistSubCategoryDetails = this._accountAssessment.scoredResultsJson.nistFunctions[this._selectedNistFunction].nistCategories[this._selectedNistCategory].nistSubCategories[this._selectedNistSubCategory];
      this.questionData = this.nistSubCategoryDetails.questions;
    }
  }

  get assessment(): AccountAssessment { return this._accountAssessment; }

  constructor(private _assessmentService: AssessmentService, private _platformApi: PlatformApiService) { }

  ngOnInit() { }


}
